<template>
    <div class="search-by">
        <input v-model="searchText" :placeholder="placeholder" class="form-control form-control-sm" :class="{'search-empty': !searchText}">
        <i @click="searchText = ''" class="search-icon" :class="{'mi-search': !searchText, 'mi-close': searchText}"></i>
    </div>
</template>

<script>
import '@/styles/general/components/search-by.scss';

export default {
    name: 'SearchBy',
    props: {
        placeholder: {
            type: String,
            default: 'Search'
        },
    },
    watch: {
        searchText(v) {
            this.$emit('change', v);
        }
    },
    data: function () {
        return {
            searchText: '',
        }
    },
}
</script>
